import React, { useEffect, useState } from "react";
import { api, inr } from "../../lib/api";
import { IndianRupee, Users, ShoppingCart, TrendingUp } from "lucide-react";

const KPI = ({ icon: Icon, label, value, k }) => (
  <div className="card-surface p-5" data-testid={`admin-kpi-card-${k}`}>
    <div className="flex items-center justify-between mb-3"><Icon className="w-5 h-5 text-ember" /></div>
    <div className="font-heading font-bold text-2xl">{value}</div>
    <div className="text-xs text-content-muted uppercase tracking-wide mt-1">{label}</div>
  </div>
);

export default function AdminDashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <div className="py-20 text-center text-content-muted">Loading…</div>;
  const f = d.funnel;
  const steps = [
    { label: "Visitors", value: f.visitors },
    { label: "Product Views", value: f.product_views },
    { label: "Checkout", value: f.checkout },
    { label: "Purchases", value: f.purchases },
  ];
  const max = Math.max(1, ...steps.map((s) => s.value));
  return (
    <div className="space-y-8">
      <h1 className="font-heading text-2xl font-bold">Dashboard</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <KPI icon={IndianRupee} label="Revenue" value={inr(d.revenue)} k="revenue" />
        <KPI icon={Users} label="Students" value={d.students.toLocaleString("en-IN")} k="students" />
        <KPI icon={ShoppingCart} label="Paid Orders" value={d.paid_orders} k="orders" />
        <KPI icon={TrendingUp} label="Conversion" value={`${d.conversion_rate}%`} k="conversion" />
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="card-surface p-5">
          <h3 className="font-heading font-semibold text-sm mb-4">Marketing funnel</h3>
          <div className="space-y-3">
            {steps.map((s) => (
              <div key={s.label}>
                <div className="flex justify-between text-xs mb-1"><span className="text-content-secondary">{s.label}</span><span className="font-mono">{s.value}</span></div>
                <div className="h-2 bg-ink rounded-full overflow-hidden"><div className="h-full btn-ember rounded-full" style={{ width: `${(s.value / max) * 100}%` }} /></div>
              </div>
            ))}
          </div>
          <div className="mt-4 text-xs text-content-muted">Avg order value: {inr(d.aov)}</div>
        </div>

        <div className="card-surface p-5">
          <h3 className="font-heading font-semibold text-sm mb-4">Traffic sources</h3>
          {d.traffic.length ? (
            <div className="space-y-2">
              {d.traffic.slice(0, 6).map((t) => (
                <div key={t.source} className="flex justify-between text-sm"><span className="text-content-secondary capitalize">{t.source}</span><span className="font-mono">{t.count}</span></div>
              ))}
            </div>
          ) : <div className="text-sm text-content-muted">No traffic data yet.</div>}
        </div>
      </div>

      <div className="card-surface p-5">
        <h3 className="font-heading font-semibold text-sm mb-4">Top products by revenue</h3>
        {d.top_products.length ? (
          <div className="space-y-2">
            {d.top_products.map((p) => (
              <div key={p.name} className="flex justify-between text-sm border-b border-line pb-2"><span className="text-content-secondary truncate mr-4">{p.name}</span><span className="font-mono shrink-0">{inr(p.revenue)}</span></div>
            ))}
          </div>
        ) : <div className="text-sm text-content-muted">No sales yet.</div>}
      </div>
    </div>
  );
}
